<template>
  <div class="page-container">
    <el-row class="tac">
      <el-col :span="4">
        <h5>관리 메뉴</h5>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          active-text-color="#6256ff"
          router>
          <el-menu-item index="/management/onuse">
            <i class="el-icon-document"></i>
            <span>사용중인 고객</span>
          </el-menu-item>
          <el-menu-item index="/management/onprepare">
            <i class="el-icon-headset"></i>
            <span>영업중인 업체</span>
          </el-menu-item>
          <el-menu-item index="/management/payment">
            <i class="el-icon-money"></i>
            <span>결제이력</span>
          </el-menu-item>
          <el-menu-item index="/management/notice">
            <i class="el-icon-chat-dot-square"></i>
            <span>공지사항</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="20">
        <router-view />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
